import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import './form.css';
import useForm from "./useForm";
import validate from './FormValidationRules';
import PrivacyModal from "./PrivacyModal";
import moment from "moment";

function CricketFrom() {
    const [modalShow, setModalShow] = React.useState(false);
    const venues = [
        {
            "city": "Mumbai",
            "venues": [
                {
                    "venue": "Hindu Gymkhana",
                    "date": "26 February 2020"
                },
                {
                    "venue": "Lions Club",
                    "date": "27 February 2020"
                }
            ]
        },
        {
            "city": "Indore",
            "venues": [
                {
                    "venue": "Yeshwant Club",
                    "date": "22 February 2020"
                }
            ]
        },
        {
            "city": "Patna",
            "venues": [
                {
                    "venue": "SSC, Moin-ul-Haq Stadium",
                    "date": "19 February 2020"
                }
            ]
        },
        {
            "city": "Ghaziabad",
            "venues": [
                {
                    "venue": "3S Cricket Academy",
                    "date": "13 February 2020"
                }
            ]
        },
        {
            "city": "Lucknow",
            "venues": [
                {
                    "venue": "La Martiniere College",
                    "date": "16 February 2020"
                }
            ]
        },
        {
            "city": "Coimbatore",
            "venues": [
                {
                    "venue": "SNR College",
                    "date": "05 March 2020"
                }
            ]
        },
        {
            "city": "Chennai",
            "venues": [
                {
                    "venue": "Cricket Drome",
                    "date": "02 March 2020"
                },
                {
                    "venue": "Alstom Cricket Ground",
                    "date": "03 March 2020"
                }
            ]
        }
    ]
    const [venue, updateVenue] = useState(venues[0].venues);
    const [vdate, updateVdate] = useState('');

    var md5 = require('md5');
    const [date, updateDate] = useState(moment().format('YYYY-MM-DD'))
    const [loader, updateLoader] = useState(false);
    const [iAgree, updateiAgree] = useState(true);
    const [nameError, updateNameError] = useState('');
    const [dobError, updateDobError] = useState('');
    // const [dateError, updateDateError] = useState('');
    // const [timeError, updateTimeError] = useState('');
    const [addressError, updateAddressError] = useState('');
    const [pincodeError, updatePincodeError] = useState('');
    const [emailError, updateEmailError] = useState('');
    const [mobileError, updateMobileError] = useState('');
    const [cityError, updateCityError] = useState('');
    const [stadiumError, updateStadiumError] = useState('');
    const [testimonilaError, updateTestimonilaError] = useState('');
    const [submitCount, updateSubmitCount] = useState(0);
    let p = Math.floor(Math.random() * (500 - 1) + 1);
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(savedata, validate);

    function savedata() {
        if (submitCount >= 1) {
            return
        }
        updateSubmitCount(submitCount + 1)

        console.log(values);
        var fullname = values.fullname;
        var dob = values.dob;
        var date = values.date;
        var address = values.address;
        var choice1 = values.choice1;
        var choice2 = values.choice2;
        var choice3 = values.choice3;
        var pincode = values.pincode;
        var email = values.email;
        var city = values.city;
        var stadium = values.stadium;
        var mobile = values.mobile;
        var termsconditions = values.termsconditions
        updateLoader(true);
        var previousurl = document.referrer;
        var data = {
            key: md5('GULF#$*%45!8HGS' + mobile),
            name: fullname,
            dob: dob,
            date: date,
            address: address,
            pincode: pincode,
            choice1: choice1,
            choice2: choice2,
            choice3: choice3,
            email: email,
            mobile: mobile,
            stadium: stadium,
            city: city,
            termsconditions: termsconditions
        }
        console.log(data);

        //fetch('http://172.16.60.37/api/pudapi/saveuserdata.php', {
        fetch('http://puydapi.gulfoilindia.com/saveuserdata.php', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            async: true,
            body: JSON.stringify(data),
        }).then(response => response.json()).then((response) => {
            // console.log(response)
            window.location.href = "/thankyou";
            updateLoader(false);
        })
        console.log('No errors, submit callback called!');
    }

    function isAlphabetKey(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (!(charCode >= 65 && charCode <= 122) && (charCode !== 32 && charCode !== 0) && charCode > 31 || (charCode >= 91 && charCode <= 96)) {
            if (evt.target.name === 'fullname') {
                evt.preventDefault()
                updateNameError('Special characters/numbers not allowed')
            }
            if (evt.target.name === 'city') {
                evt.preventDefault()
                updateCityError('Special characters/numbers not allowed')
            }
            if (evt.target.name === 'stadium') {
                evt.preventDefault()
                updateStadiumError('Special characters/numbers not allowed')
            }
        } else {
            if (evt.target.name === 'fullname') {
                // errors.fullname = ''; 
                updateNameError('')
            }
            if (evt.target.name === 'dob') {
                // errors.fullname = ''; 
                updateDobError('')
            }
            // if (evt.target.name === 'date') {
            //     // errors.fullname = ''; 
            //     updateDateError('')
            // }
            if (evt.target.name === 'address') {
                // errors.fullname = ''; 
                updateAddressError('')
            }
            if (evt.target.name === 'pincode') {
                // errors.fullname = ''; 
                updatePincodeError('')
            }
            if (evt.target.name === 'city') {
                // errors.city = '';
                updateCityError('')
            }

            if (evt.target.name === 'stadium') {
                // errors.city = '';
                updateStadiumError('')
            }
        }
        return errors;
    }
    function isNumberKey(evt) {
        const isNumer = /^[0-9\b]+$/;;
        if (typeof window !== "undefined") {
            evt = evt || window.event;
        }
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        // if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode >= 96 && charCode <= 105) && (charCode !== 17 && charCode !== 86) && charCode !== 46) {
        if (!evt.shiftKey && !evt.altKey && !evt.ctrlKey &&
            // numbers   
            charCode >= 48 && charCode <= 57 ||
            // Numeric keypad
            charCode >= 96 && charCode <= 105 ||
            // comma, period and minus, . on keypad
            charCode == 190 || charCode == 188 || charCode == 109 || charCode == 110 ||
            // Backspace and Tab and Enter
            charCode == 8 || charCode == 9 || charCode == 13 ||
            // Home and End
            charCode == 35 || charCode == 36 ||
            // left and right arrows
            charCode == 37 || charCode == 39 ||
            // Del and Ins
            charCode == 46 || charCode == 45) {
            updateMobileError('');
            // return true
        } else {
            evt.preventDefault()
            if (evt.target.name === 'mobile') {
                evt.preventDefault()
                updateMobileError('Alphabets/Special characters not allowed')
            } else if (evt.target.name === 'pincode') {
                evt.preventDefault()
                updatePincodeError('Alphabets/Special characters not allowed')
            }
            return errors;
        }
        //  else {
        // // errors.mobile = "";

        // }

    }
    function testMein(e) {
        if (e.target.name === 'city') {
            var city = e.target.value;
            for (let v = 0; v < venues.length; v++) {
                if (venues[v].city === city) {
                    updateVenue(venues[v].venues)
                    updateVdate('');
                    values.date = '';
                }
            }
        }
        if (e.target.name === 'stadium') {
            var dvenue = e.target.value;
            for (let v = 0; v < venue.length; v++) {
                if (venue[v].venue === dvenue) {
                    updateVdate(venue[v].date);
                    values.date = venue[v].date
                }
            }
        }
    }
    function onBlur(e) {
        if (e.target.name === 'fullname' && (e.target.value.trim() == '')) {
            updateNameError('Please enter valid name')
        } else {
            updateNameError('')
        }
        if (e.target.name === 'dob' && (e.target.value.trim() == '')) {
            updateDobError('Please enter valid date of birth')
        } else {
            updateDobError('')
        }
        // if (e.target.name === 'date' && (e.target.value.trim() == '')) {
        //     updateDateError('Please enter valid date')
        // } else {
        //     updateDateError('')
        // }
        if (e.target.name === 'address' && (e.target.value.trim() == '')) {
            updateAddressError('Please enter valid address')
        } else {
            updateAddressError('')
        }
        if (e.target.name === 'pincode' && (e.target.value.trim() == '')) {
            updatePincodeError('Please enter valid pincode')
        } else {
            updatePincodeError('')
        }
        if (e.target.name === 'city' && (e.target.value.trim() == '')) {
            updateCityError('Please enter valid Location')
        } else {
            updateCityError('')
        }
        if (e.target.name === 'stadium' && (e.target.value.trim() == '')) {
            updateStadiumError('Please enter valid Stadium')
        } else {
            updateStadiumError('')
        }
        if (e.target.name === 'mobile' && (e.target.value === "0000000000" || e.target.value === "6666666666" || e.target.value === "7777777777" || e.target.value === "8888888888" || e.target.value === "9999999999" || e.target.value === "9876543210" || e.target.value === "0123456789")) {
            updateMobileError('Please enter valid mobile number')
            errors.mobile = "";
            return
        } else if (e.target.name === 'mobile' && e.target.value.length < 10) {
            updateMobileError('Your mobile number must contain 10 digits')
            errors.mobile = "";
            return
        } else {
            updateMobileError('')
        }
        if (e.target.name === 'email' && (e.target.value.trim() == '')) {
            updateEmailError('Email address is invalid');
        } else {
            updateEmailError('')
        }
        if (e.target.name === 'email' && (!/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(e.target.value))) {
            updateEmailError('Email address is invalid');
            errors.email = "";
        } else {
            updateEmailError('')
        }
    }
    function errorTestimonial(e) {
        // iAgree, updateiAgree
        updateiAgree(!iAgree)
        console.log(iAgree)
        if (iAgree) {
            updateTestimonilaError('Please accept terms and conditions');

        } else {
            updateTestimonilaError('')

        }
    }
    function clearAll(e) {
        updateNameError('')
        updateDobError('')
        //updateDateError('')
        // updateTimeError('')
        updateAddressError('')
        updatePincodeError('')
        updateCityError('')
        updateStadiumError('')
        updateMobileError('')
        updateEmailError('')
        updateTestimonilaError('')
    }
    function clearError() {
        errors.fullname = ''
        errors.dob = ''
        //errors.date = ''
        errors.address = ''
        errors.pincode = ''
        errors.mobile = ''
        errors.email = ''
        errors.city = ''
        errors.stadium = ''
    }

    return (
        <div>
            <Form noValidate onSubmit={handleSubmit} className="register-form">
                <Row>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalName" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Name</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="text" className={`crick-field ${errors.fullname && 'danger m-0'}`} name="fullname" onBlur={(e) => onBlur(e)} onFocus={() => clearError()} onChange={(handleChange)} onKeyDown={(e) => isAlphabetKey(e)} value={values.fullname || ''} required placeholder="Your Name" />
                                <p className="error m-0" id="nameSpan1">{nameError}</p>
                                {errors.fullname && (
                                    <p className="error m-0" id="nameSpan">{errors.fullname}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalName" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Date of Birth</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="date" max={date} className={`crick-field ${errors.dob && 'danger m-0'}`} name="dob" onBlur={(e) => onBlur(e)} onFocus={() => clearError()} onChange={(handleChange)} onKeyDown={(e) => isAlphabetKey(e)} value={values.dob || ''} required placeholder="Date of Birth" />
                                <p className="error m-0" id="nameSpan1">{dobError}</p>
                                {errors.dob && (
                                    <p className="error m-0" id="nameSpan">{errors.dob}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalAddress" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Address</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="text" className={`crick-field ${errors.address && 'danger m-0'}`} name="address" onBlur={(e) => onBlur(e)} onFocus={() => clearError()} onChange={(handleChange)} onKeyDown={(e) => isAlphabetKey(e)} value={values.address || ''} required placeholder="Enter your address" />
                                <p className="error m-0" id="nameSpan1">{addressError}</p>
                                {errors.address && (
                                    <p className="error m-0" id="nameSpan">{errors.address}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalName" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Pin Code</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="text" className={`crick-field ${errors.pincode && 'danger m-0'}`} name="pincode" onBlur={(e) => onBlur(e)} onFocus={() => clearError()} onChange={(handleChange)} maxLength="6" onKeyDown={(e) => isNumberKey(e)} value={values.pincode || ''} required placeholder="Enter your pin code" />
                                <p className="error m-0" id="nameSpan1">{pincodeError}</p>
                                {errors.pincode && (
                                    <p className="error m-0" id="nameSpan">{errors.pincode}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalAddress" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Mobile</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="tel" placeholder="" className={`crick-field form-ico ${errors.mobile && 'danger m-0'}`} onBlur={(e) => onBlur(e)} name="mobile" maxLength="10" onFocus={() => clearError()} onKeyDown={(e) => isNumberKey(e)} onChange={handleChange} value={values.mobile || ''} required placeholder="Your Mobile No" />
                                <p className="error m-0">{mobileError}</p>
                                {errors.mobile && (
                                    <p className="error m-0">{errors.mobile}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group as={Row} controlId="formHorizontalName" className="no-gutters">
                            <Form.Label column sm={4} className="crick-label">Email Address</Form.Label>
                            <Col sm={8} className="align-self-center">
                                <Form.Control type="email" className={`crick-field ${errors.email && 'danger m-0'}`} name="email" onFocus={() => clearError()} onChange={handleChange} value={values.email || ''} onBlur={(e) => onBlur(e)} required placeholder="Email Address" />
                                <p className="error m-0">{emailError}</p>
                                {errors.email && (
                                    <p className="error m-0">{errors.email}</p>
                                )}
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <fieldset>
                            <Form.Group as={Row} className="no-gutters">
                                <Form.Label as="legend" column sm={12} md={2} className="crick-label">Select</Form.Label>
                                <Col sm={12} md={10} className="align-self-end">
                                    <div className="cricket-btn">
                                        <div className="crk-board d-inline-block mr-2 mb-2">
                                            <Form.Check
                                                custom
                                                inline
                                                label="Batting"
                                                type="checkbox"
                                                className="crick-label"
                                                name="choice1"
                                                value="Batting"
                                                id="choice1"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="crk-board d-inline-block mr-2 mb-2">
                                            <Form.Check
                                                custom
                                                inline
                                                label="Bowling"
                                                type="checkbox"
                                                className="crick-label"
                                                name="choice2"
                                                value="Bowling"
                                                id="choice2"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="crk-board d-inline-block mr-2 mb-2">
                                            <Form.Check
                                                custom
                                                inline
                                                label="Wicket Keeping"
                                                type="checkbox"
                                                className="crick-label"
                                                name="choice3"
                                                value="WicketKeeping" id="choice3"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="d-inline-block crick-label">(Select any 2)</div>
                                        {errors.choice1 && (
                                            <p className="error m-0">{errors.choice1}</p>
                                        )}
                                    </div>
                                </Col>
                            </Form.Group>
                        </fieldset>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Form.Group controlId="exampleForm.ControlSelect1" as={Row} className="no-gutters">
                            <Form.Label column sm={12} md={2} className="crick-label">Venue</Form.Label>
                            <Col sm="4" md="2">
                                <Form.Group controlId="formHorizontalName">
                                    <Form.Control as="select" className={`crick-field ${errors.city && 'danger m-0'}`} name="city" onBlur={(e) => onBlur(e)} onChange={(e) => { testMein(e); handleChange(e) }} onFocus={() => clearError()} value={values.city || ''} required placeholder="Your City">
                                        <option>Select City</option>
                                        {venues.map((city, i) => {
                                            return (<option key={i}>{city.city}</option>)
                                        })}
                                    </Form.Control>
                                    <p className="error m-0">{cityError}</p>
                                    {errors.city && (
                                        <p className="error m-0">{errors.city}</p>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm="4">
                                <Form.Group controlId="formHorizontalName">
                                    <Form.Control as="select" className={`crick-field ${errors.stadium && 'danger m-0'}`} name="stadium" onBlur={(e) => onBlur(e)} onChange={(e) => { testMein(e); handleChange(e) }} onFocus={() => clearError()} onKeyDown={(e) => isNumberKey(e)} value={values.stadium || ''} required placeholder="Your Stadium">
                                        <option>Select Stadium</option>
                                        {venue.map((venue, i) => {
                                            return (<option key={i}>{venue.venue}</option>)
                                        })}
                                    </Form.Control>
                                    <p className="error m-0">{stadiumError}</p>
                                    {errors.stadium && (
                                        <p className="error m-0">{errors.stadium}</p>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm="4">
                                <Form.Group controlId="formHorizontalName">
                                    <div className="align-self-center">
                                        <Form.Control type="input" readOnly className={`crick-field ${errors.date && 'danger m-0'}`} name="date" onBlur={(e) => onBlur(e)} onFocus={() => clearError()} onChange={(handleChange)} onKeyDown={(e) => isNumberKey(e)} value={values.date || ''} placeholder="Date" />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <p>An email of the registration form will be sent to your email address. Please carry a print <br className="d-none d-lg-block" /> of the same for the trials.</p>
                <Form.Check
                    custom
                    inline
                    id="terms"
                    label={`I agree with the`}
                    className="crick-tnc mr-0"
                    name="termsconditions"
                    onChange={(handleChange)}
                /> <a href="#" className="tnc" onClick={(e) => { setModalShow(true); e.preventDefault() }}>terms &amp; conditions</a>
                {errors.termsconditions && (
                    <p className="error m-0">{errors.termsconditions}</p>
                )}

                <div className="my-3">
                    <Button type="submit" id="send" name="send" variant="primary orange-btn" type="submit">Submit</Button>
                    <br />
                    <div className={loader ? 'lds-ellipsis' : 'd-none'}><div></div><div></div><div></div><div></div></div>
                </div>
            </Form>
            <PrivacyModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    );
}
export default CricketFrom;